enum Category {
  ALL = 'all',
  GROUP = 'group',
  HASHTAG = 'hashtag',
  PERSONAL = 'home',
  PROFILE = 'profile',
}

export default Category;
